class Storage {
    store(key, data) {
        global.localStorage.setItem(key, JSON.stringify(data));
    }
    getJson(key) {
        return (JSON.parse(global.localStorage.getItem(key)));
    }
    get(key) {
        return global.localStorage.getItem(key);
    }
    remove(key) {
        global.localStorage.removeItem(key);
    }
    clearAll() {
        for (var i = localStorage.length - 1; i >= 0; i--) {
            // for (var i = 0; i <= localStorage.length; i++) {
            var key = localStorage.key(i);
        
            // Check if the key starts with the specified prefix
            if (key && !key.startsWith("/qms") && !key.startsWith("/otm")  ) {
                // Remove the key-value pair from localStorage
                localStorage.removeItem(key);

            }
        }
        // global.localStorage.clear();
    }

}
export default (new Storage());
//exports();
